module.exports = __webpack_public_path__ + "static/img/logo.20269b0c.png";